import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceService } from 'src/services/auth-service.service';
import { MenuInfo } from '../models/menu-info';

@Injectable({
  providedIn: 'root'
})
export class CanActivateGuard implements CanActivate {
  currentRoute: any

  menuInfo = [];

  constructor(
    private auth: AuthServiceService,
    private router: Router) { this.currentRoute = this.router.url,
                              this.menuInfo = this.auth.menuInfo }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> | Promise<boolean> | boolean {
    this.currentRoute = this.getResolvedUrl(route);
    this.currentRoute = '/' + this.currentRoute
    let guardFlag = localStorage.getItem("guardFlag")
    if(guardFlag == "false"){
      if(this.checkValidity() == true) {
        return true;
      }
      return false;
    }
    else if(guardFlag == "true")
    {
      localStorage.setItem("guardFlag","false")
      return true
    }
  }

  getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
        .map(v => v.url.map(segment => segment.toString()))
        .join('');
  }

  checkValidity() : boolean {
    let returnValue = false
    if(this.auth.menuInfo == null || []) {
      this.auth.menuInfo = JSON.parse(localStorage.getItem('menuInfo'));
    }
    loop1: for(let item of this.auth.menuInfo) {
      if(item.checked == true || item.indeterminate == true ) {
          if(this.currentRoute == item.menuUrl) {
            if(item.subMenu.length > 0) {
              for(let ele of item.subMenu) {
                if(this.currentRoute == ele.menuUrl){
                  if(ele.checked == true || ele.indeterminate == true){
                    returnValue = true
                    break loop1
                  }
                }
              }
            }
            else {
              returnValue = true;
              break loop1;
            }
          }
          else if(item.subMenu.length > 0) {
            for(let ele of item.subMenu) {
              if(this.currentRoute == ele.menuUrl) {
                if(ele.checked == true || ele.indeterminate == true) {
                    returnValue = true;
                    break loop1
                }
              }
            }
          }
      } 
      else if(item.subMenu.length > 0) {
        for(let ele of item.subMenu) {
          if(this.currentRoute == ele.menuUrl) {
            if(ele.checked == true || ele.indeterminate == true) {
              returnValue = true;
              break loop1
            }
          }
        }
      }
    } 
    return returnValue;
  }
  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
  //   : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //     return this.auth.pathValidityMain(state);
  // }

  // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
  //   return this.auth.pathValiditySub(state);
  // }
}